<template>
  <div v-if="studios" id="about">
    <MenuSingle :project="project" />

    <div class="grid linelayer" :class="{showLines: $store.state.lines}" v-if="project">
      <TopHome />

      <template v-for="item in filtered">
        <div class="single" :class="[item.category, 'width' + item.width]" :key="item.title">
          <div class="aboutTitle">
            <span class="highlight" v-html="item.title"></span><br>
          </div>

          <div class="textGrid" v-if="item.text">
            <div class="textLines">
              <div class="lines">
                <div class="line c b vertical"></div>
                <div class="line c l horizontal"></div>
                <div class="line c r horizontal"></div>
                <div class="mobLine"></div>
              </div>
            </div>

            <div class="textGridInner">
              <div class="text" v-html="item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="grid contentlayer" :class="{showLines: $store.state.lines}" v-if="project">
      <TopHome />

      <template v-for="item in filtered">
        <div class="single" :class="[item.category, 'width' + item.width]" :key="item.title" v-if="item.text">
          <div class="aboutTitle">

            <template v-if="item.type === 'studio' || item.type === 'category'">
              <router-link @mouseenter.native="showlines" @mouseleave.native="showlines" @touchstart.native="touchlines" @touchend.native="touchlines" :to="'/' + item.type + '/' + item.slug">
                <span class="highlight" v-html="item.title"></span><br>
              </router-link>
            </template>

            <template v-else>
              <span class="highlight" v-html="item.title" @mouseenter="showlines" @mouseleave="showlines" @touchstart="touchlines" @touchend="touchlines"></span><br>
            </template>
          </div>

          <div class="textGrid" v-if="item.text">
            <div class="textGridInner">
              <div class="text" v-html="item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import TopHome from '@/components/GridTopHome'
import MenuSingle from '@/components/MenuSingle'
import ShowLines from '@/components/ShowLines.js'

export default {
  components: {
    TopHome,
    MenuSingle
  },

  computed: {
    project () {
      return this.$store.getters.about
    },

    studios () {
      return this.$store.getters.studios
    },

    categories () {
      return this.$store.getters.categories
    },

    filtered () {
      let filtered = []
      let about = {
        title: 'About',
        text: this.project.text,
        type: 'info',
        width: 1
      }

      let contact = {
        title: 'Contact',
        text: this.project.address,
        type: 'info',
        width: 0
      }

      let credits = {
        title: 'Site Web',
        text: this.project.credits,
        type: 'info',
        width: 0
      }

      filtered.push(about, contact)
      let items = filtered.concat(this.categories)
      items.push(credits)
      return items
    }
  },

  mixins: [ShowLines]
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';
@import '@/assets/css/single.scss';

.topSpacer.grid.singleGrid {
  z-index: -1;
}

.linelayer {
  .text, .aboutTitle {
    visibility: hidden;
  }
}

#about {
  position: relative;

  .single {
    grid-template-rows: auto;
  }

  .contentlayer {
    z-index: 5;
  }

  .single .lines {
    display: block;
    grid-column: span 1;
    grid-column-end: -1;
  }

  .single:last-child .lines {
    display: none;
  }

  .single:nth-child(even) {
    .c.r {
      display: none;
    }
  }

  .lines {
    position: absolute;
  }

  .single:nth-child(odd) {
    grid-column-end: -1;

    .lines {
      grid-column-end: 2;
    }

    .c.l {
      display: none;
    }

    .text {
      padding-left: 6px;
      padding-right: 0;
      grid-column-end: -1;
    }

    .aboutTitle {
      grid-column-end: -1;
    }
  }

  .width0 .text {
    grid-column: span 1;
  }

  .single .c.r {
    right: calc(-100% - #{$padding} * 2;
  }

  .single .c.l {
    left: calc(-100% - #{$padding} * 2;
  }

  .single .c.b {
    bottom: -4rem;
  }

  .textGrid {
    position: relative;
    grid-column: span 3;
  }

  .textGridInner {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: $padding;
    display: grid;
  }

  .textLines {
    display: grid;
    position: absolute;
    width: 100%;
    height: 100%;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    grid-column-gap: $padding;
  }

  .textLines.width0 {
    grid-template-columns: repeat(1, 1fr);
  }

  .text {
    font-size: $mediumtext;
    padding: 6px 6px 6px 0;
    position: relative;
  }

  .aboutTitle {
    background-color: white;
    text-align: center;
    grid-column: span 1;
    padding-bottom: 1rem;

    a,
    .highlight {
      pointer-events: auto;
    }
  }

  .catTitle {
    text-transform: capitalize;
  }

  .halfBlockAbout {
    height: 15rem;
  }

  .topSpacer .c.b {
    bottom: -4rem;
  }
}

@media screen and (max-width: $breakPoint1) {
  #about {
    .grid {
      grid-row-gap: calc(#{$mobpadding} * 2);
    }

    .textGridInner {
      grid-template-columns: repeat(1, 1fr);
    }

    .single {
      display: block;
    }

    .single .c.r {
      right: calc(-100% - #{$mobpadding} * 2;
    }

    .single .c.l {
      left: calc(-100% - #{$mobpadding} * 2;
    }

    .textGridInner {
      grid-column-gap: $mobpadding;
    }

    .lines {
      position: absolute;
    }

    .mobLine {
      bottom: calc(-#{$mobpadding} * 2);
    }

    .textLines {
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
</style>
